import React from 'react';
import {
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import MaskedInput from '../../Template/Input/MaskedInput';
import CotacaoRapidaPropostasSection from './CotacaoRapidaPropostasSection';
import {
  cotacaoFormTemDados,
  createEmptyCotacaoForm,
  normalizeCotacaoManualEntry,
  serializeCotacoesManuaisForPayload,
  validateCotacaoForm,
} from './cotacaoRapidaFormUtils';

export { serializeCotacoesManuaisForPayload, createEmptyCotacaoForm };

const IndicacaoCotacaoRapidaForm = React.forwardRef(({
  indicacao = {},
  onChange = () => {},
  disabled = false,
}, ref) => {
  const [cotacaoForm, setCotacaoForm] = React.useState(createEmptyCotacaoForm);

  const cotacoesManuais = Array.isArray(indicacao?.cotacoesManuais)
    ? indicacao.cotacoesManuais
    : [];

  const updateIndicacao = React.useCallback((patch) => {
    onChange({
      ...(indicacao || {}),
      ...patch,
    });
  }, [indicacao, onChange]);

  const buildIndicacaoWithPending = React.useCallback(() => {
    const nextCotacoes = [...cotacoesManuais];

    if (cotacaoFormTemDados(cotacaoForm)) {
      if (!validateCotacaoForm(cotacaoForm)) {
        return null;
      }
      nextCotacoes.push(normalizeCotacaoManualEntry(cotacaoForm));
    }

    return {
      ...(indicacao || {}),
      cotacoesManuais: nextCotacoes,
    };
  }, [cotacaoForm, cotacoesManuais, indicacao]);

  React.useImperativeHandle(ref, () => ({
    getValue: () => buildIndicacaoWithPending(),
    resetDraft: () => setCotacaoForm(createEmptyCotacaoForm()),
  }), [buildIndicacaoWithPending]);

  return (
    <>
      <FormGroup>
        <Label>Objeto</Label>
        <Input
          type="textarea"
          rows={4}
          placeholder="Escreva o objeto da indicação ou da cotação"
          disabled={disabled}
          value={indicacao?.pedidoCompra_desc || ''}
          onChange={(e) => {
            updateIndicacao({ pedidoCompra_desc: e.target.value });
          }}
        />
      </FormGroup>

      <FormGroup>
        <Label>Valor estimado</Label>
        <MaskedInput
          unmask
          mask="R$ num"
          disabled={disabled}
          blocks={{
            num: {
              mask: Number,
              scale: 2,
              signed: false,
              thousandsSeparator: '.',
              padFractionalZeros: false,
              normalizeZeros: false,
              radix: ',',
              min: 0,
              max: 1000000000,
            },
          }}
          lazy={false}
          value={String(indicacao?.pedidoCompra_vlrLimite ?? '')}
          onAccept={(value) => {
            if (!disabled) {
              updateIndicacao({ pedidoCompra_vlrLimite: value });
            }
          }}
        />
      </FormGroup>

      {!disabled && (
        <CotacaoRapidaPropostasSection
          cotacaoForm={cotacaoForm}
          setCotacaoForm={setCotacaoForm}
          cotacoesManuais={cotacoesManuais}
          onChangeCotacoesManuais={(next) => updateIndicacao({ cotacoesManuais: next })}
          disabled={disabled}
          showAnexos={true}
          idPrefix="indicacao"
          deferralHint="Você também pode salvar a indicação agora e incluir propostas depois."
        />
      )}
    </>
  );
});

IndicacaoCotacaoRapidaForm.displayName = 'IndicacaoCotacaoRapidaForm';

export default IndicacaoCotacaoRapidaForm;
